<template>
    <section class="empty-page">
        <div class="empty-page__inner">
            <h1>
                <iv-icon type="ios-information"></iv-icon>
                <span>404</span>
            </h1>
            <div>
                <span>找不到您的页面，你可以尝试</span>
                <a href="javascript:history.back();">取消</a>
                <span>或</span>
                <router-link to="/">回到首页</router-link>
            </div>
        </div>
    </section>
</template>
<style lang="scss" scoped>
.empty-page{
    min-height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;
    .ivu-icon{
        vertical-align: top;
        color: rgb(243, 164, 1);
    }
    &__inner{
        border: solid 1px #ddd;
        padding: 2em;
        > h1{
            font-size: 32px;
            line-height: 1;
            margin-bottom: 1rem;
        }
    }
}
</style>
<script>
export default {
    data(){
        return {
        }
    }
}
</script>

